import { render, staticRenderFns } from "./Fabrication.vue?vue&type=template&id=20048484&"
import script from "./Fabrication.vue?vue&type=script&lang=js&"
export * from "./Fabrication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports